import { Component, ErrorInfo, ReactNode } from "react";

import { Button } from "@iwoca/orion";
import { Trans } from "@lingui/react/macro";

import TokenContainer from "./Login/TokenViews/TokenContainer";
import styles from "./Login/TokenViews/TokenContainer.module.css";
import logger from "./utils/logger";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error("Unhandled render error", {
      error: error.message,
      errorName: error.name,
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <TokenContainer data-testid="app-error-view">
        <h1 className={styles.tokenResponseTitle}>
          <Trans>Hmm, something's gone wrong</Trans>
        </h1>

        <Button
          variant="primary"
          className={styles.tokenResponseCTA}
          onClick={() => window.location.reload()}
        >
          <Trans>Try Again</Trans>
        </Button>
      </TokenContainer>
    );
  }
}

export default AppErrorBoundary;
